import axios from "axios";
import { api } from "../config";
import { getRefreshToken } from "./backend_helper";

axios.defaults.baseURL = api.API_URL;

axios.defaults.headers.post["Content-Type"] = "application/json";

const accessToken = JSON.parse(sessionStorage.getItem("authUser"))
  ? JSON.parse(sessionStorage.getItem("authUser")).access
  : null;

if (accessToken)
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const getNewToken = async (refreshToken) => {
  try {
    console.log("getNewToken called");
    const { access } = await getRefreshToken({ refresh: refreshToken });
    console.log("New Access Token:", access);

    setAuthorization(access);
    sessionStorage.setItem(
      "authUser",
      JSON.stringify({ access, refresh: refreshToken })
    );

    return access;
  } catch (error) {
    console.error("Refresh Token Error:", error);
    throw error;
  }
};

let isRefreshing = false;

const publicEndpoints = [
  "/users/login/",
  "/users/register/",
  "/users/reset-password/",
  "/users/set-password/",
  "/users/verify-reset-otp/",
];

axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  async function (error) {
    if (!error.response) {
      return Promise.reject("Network Error");
    }

    const originalRequest = error.config;

    console.log("originalRequest", originalRequest);

    const isPublicEndpoint = publicEndpoints.some((endpoint) =>
      originalRequest.url?.includes(endpoint)
    );

    if (!isPublicEndpoint) {
      console.log("in if");
      if (error.response.status === 401 && !originalRequest._retry) {
        const refreshToken = JSON.parse(
          sessionStorage.getItem("authUser")
        )?.refresh;
        if (!refreshToken) {
          sessionStorage.removeItem("authUser");
          return Promise.reject("Session expired, please log in again.");
        }

        if (isRefreshing) {
          return Promise.reject("Token refresh already in progress.");
        }

        isRefreshing = true;
        originalRequest._retry = true;

        try {
          const newAccessToken = await getNewToken(refreshToken);
          if (newAccessToken) {
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + newAccessToken;
            originalRequest.headers["Authorization"] =
              "Bearer " + newAccessToken;
            return axios(originalRequest);
          }
        } catch (refreshError) {
          console.error("Refresh token failed, logging out:", refreshError);
          sessionStorage.removeItem("authUser");
          window.location.href = "/login";
        } finally {
          isRefreshing = false;
        }
      }
    }

    return Promise.reject(error);
  }
);

/**
 * Sets the default authorization
 * @param {*} accessToken
 */
const setAuthorization = (accessToken) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
};

class APIClient {
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);

    }
    return response;
  };
  post = (url, data, config = {}) => {
    return axios.post(url, data, config);
  };

  patch = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };

  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
